import { Component } from '@angular/core';
import {PrivacyPolicyFactory} from "./privacy-policy-factory.component";

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {
  protected readonly secondaryParts = PrivacyPolicyFactory.SECONDARY_PARTS
  protected readonly privacyPrinciples= PrivacyPolicyFactory.PRIVACY_PRINCIPLES;
}
